import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";

import { HeaderStyle } from "../fonts";
//@ts-ignore
import FrontCover from "../assets/Cover.mp4";

const Cover = (props) => {
  const { checked } = props;

  return (
    <Slide
      direction={"left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          height: { xs: "100svh", sm: "100vh" },
          width: "100%",
          bgcolor: "#D7D7D7",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
            justifyContent: "center",
          }}
        >
          <Grid item xs={12} sm={9} lg={5.5}>
            <Grid
              container
              direction={"column"}
              sx={{
                height: "100%",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Grid
                item
                xs
                sx={{
                  borderLeft: "1vh solid #fff",
                  borderRight: "1vh solid #fff",
                  borderTop: "1vh solid #fff",
                }}
              >
                <CardMedia
                  component={"video"}
                  playsInline
                  autoPlay
                  loop
                  muted
                  preload="auto"
                  sx={{
                    height: { xs: "65svh", sm: "65vh" },
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                  src={FrontCover}
                />
              </Grid>

              <Grid
                item
                xs
                sx={{
                  height: "100%",
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  pr: 2,
                }}
              >
                <Typography
                  sx={{
                    ...HeaderStyle,
                    "@media (orientation: landscape)": {
                      fontSize: { xs: "2vw", lg: "2vw" },
                    },
                    "@media (orientation: portrait)": {
                      fontSize: { xs: "4vw", lg: "5vw" },
                    },
                    color: "#ba2525",
                  }}
                >
                  6 O'Hara Place
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Cover;
